export default {
    oauth: {},
    isLoggedIn: false,
    connectedActor: {},
    connectedUser:{},
};